<template>
  <div class="container">

    <div class="title" v-if="!editId">新建项目{{ editId }}
      <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>
    <div class="title" v-else>
      <span>项目立项</span> <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>

    <div class="wrap">

    <el-form :model="project" label-width="auto"  ref="form" label-position="top"  @submit.prevent :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input v-model="project.project_name" placeholder="请输入项目名称"  disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="预计周期" prop="dateRangeTime">
  
            <el-date-picker
              v-model="project.dateRangeTime"
              type="datetimerange"
              range-separator="到"
              start-placeholder="预计开始时间"
              end-placeholder="预计结束时间"
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              :size="size"
            />
            
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="3">
          
          <el-form-item label="对内工时(H)" prop="inner_hours">
            <el-input-number v-model="project.inner_hours"  min="0" />
          </el-form-item>
         
        </el-col>
        <el-col :span="3">
          
          <el-form-item label="对外工时(H)" prop="outer_hours">
              <el-input-number v-model="project.outer_hours"  min="0" />
            </el-form-item>
         
        </el-col>

        <el-col :span="3">
          
          <el-form-item label="预计开发工时(H)" prop="estimate_develop_hours">
              <el-input-number v-model="project.estimate_develop_hours" min="0" />
          </el-form-item>
         
        </el-col>
        <el-col :span="3">
          
          <el-form-item label="预计测试工时(H)" prop="estimate_test_hours">
              <el-input-number v-model="project.estimate_test_hours"  min="0" />
          </el-form-item>
         
        </el-col>


      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="基础工时(H)" prop="base_hours">
            <el-input-number v-model="project.base_hours" min="0"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="submit">
              <el-button type="primary" @click="submitForm">保 存</el-button>
              <el-button @click="resetForm">重 置</el-button>
            </el-form-item>
        </el-col>
      </el-row>

    </el-form>
      


    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted,computed } from 'vue'
import { ElMessage } from 'element-plus'
import ProjectInfo from '@/model/projectInfo'

export default {
  props: {
    editId: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    const form = ref(null)
    const loading = ref(false)

    const project = reactive({ 
      id:''
      ,project_name:''
      ,date_range:''
      ,dateRangeTime:[]
      ,inner_hours:0
      ,outer_hours:0
      ,base_hours:0
      ,estimate_start_time:''
      ,estimate_complete_time:''
      ,estimate_develop_hours:''
      ,estimate_test_hours:''
    })

   

    const listAssign = (a, b) => Object.keys(a).forEach(key => {
      a[key] = b[key] || a[key]
    })


    
    /**
     * 表单规则验证
     */
    const { rules } = getRules()

    onMounted(() => {

      loadDictDitems()
      
      
    })

    //根据字典类型查询字典
    const loadDictDitems =async () =>{

      if (props.editId) {
        await getProjectInfo()
      
      }

    }

    const getProjectInfo = async () => {
      loading.value = true
      const res = await ProjectInfo.getProjectInfo(props.editId)

      listAssign(project, res)
     
     
      loading.value = false
    }

    // 重置表单
    const resetForm = () => {
      form.value.resetFields()
    }

    const submitForm = async formName => {
      form.value.validate(async valid => {
        
        project.estimate_start_time=project.dateRangeTime[0]
        project.estimate_complete_time=project.dateRangeTime[1]
        if (valid) {
          let res = {}
          if (props.editId) {
            
            res = await ProjectInfo.editProjectSetUp(props.editId, project)
            context.emit('editClose')
          }
          if (res.code < window.MAX_SUCCESS_CODE) {
            ElMessage.success(`${res.message}`)
          }
        } else {
          console.error('error submit!!')
          ElMessage.error('请将信息填写完整')
        }
      })
    }

    const back = () => {
      context.emit('editClose')
    }

    return {
      back,
      project,
      form,
      rules,
      resetForm,
      submitForm,


    }
  },
}

/**
 * 表单验证规则
 */
function getRules() {
  /**
   * 验证回调函数
   */
  const checkInfo = (rule, value, callback) => {
    if (!value) {
      callback(new Error('信息不能为空'))
    }
    callback()
  }

  const checkDateRangeTime = (rule, value, callback) => {
    if (!value||value.length==0) {
      callback(new Error('信息不能为空'))
    }
    callback()
  }


  const rules = {
    dateRangeTime: [{ validator: checkDateRangeTime, trigger: 'blur', required: true }],

    inner_hours: [{ validator: checkInfo, trigger: 'blur', required: true }],
    outer_hours: [{ validator: checkInfo, trigger: 'blur', required: true }],
    
    estimate_start_time: [{ validator: checkInfo, trigger: 'blur', required: true }],
    estimate_complete_time: [{ validator: checkInfo, trigger: 'blur', required: true }],
    estimate_develop_hours: [{ validator: checkInfo, trigger: 'blur', required: true }],
    estimate_test_hours: [{ validator: checkInfo, trigger: 'blur', required: true }],
  }
  return { rules }
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
